const MONTHLY_CHECK_IN_CONTENT_VERSION = "2026-08-04.monthly-check-in.v1";

const showsMonthlyFollowUpQuestions = (formData) =>
  Boolean(formData?.RH_MO_WORSENING_EPISODE) &&
  formData.RH_MO_WORSENING_EPISODE !== "NO";

const monthlyCheckInQuestionnaire = [
  {
    id: "RH_MO_WORSENING_EPISODE",
    titleKey: "worseningEpisode.title",
    title: "Worsening episode",
    fieldType: "radio",
    required: true,
    options: [
      {
        value: "NO",
        labelKey: "worseningEpisode.options.no",
      },
      {
        value: "YES_RECOVERED",
        labelKey: "worseningEpisode.options.yesRecovered",
      },
      {
        value: "YES_ONGOING",
        labelKey: "worseningEpisode.options.yesOngoing",
      },
      {
        value: "UNSURE",
        labelKey: "worseningEpisode.options.unsure",
      },
    ],
    group: "monthly-check-in",
  },
  {
    id: "RH_MO_EPISODE_TIMING",
    titleKey: "episodeTiming.title",
    title: "Episode timing",
    fieldType: "episode-timing",
    required: true,
    timingFields: {
      onsetDateLabelKey: "episodeTiming.onsetDateLabel",
      durationDaysLabelKey: "episodeTiming.durationDaysLabel",
      ongoingLabelKey: "episodeTiming.ongoingLabel",
      unknownLabelKey: "episodeTiming.unknownLabel",
      ongoingOptions: [
        {
          value: true,
          labelKey: "episodeTiming.ongoingOptions.yes",
        },
        {
          value: false,
          labelKey: "episodeTiming.ongoingOptions.no",
        },
      ],
    },
    condition: showsMonthlyFollowUpQuestions,
    group: "monthly-check-in",
  },
  {
    id: "RH_MO_EPISODE_SYMPTOMS",
    titleKey: "episodeSymptoms.title",
    title: "Symptoms",
    helperTextKey: "episodeSymptoms.helperText",
    fieldType: "checkbox-group",
    required: true,
    options: [
      {
        value: "breathlessness",
        labelKey: "episodeSymptoms.options.breathlessness",
      },
      {
        value: "cough",
        labelKey: "episodeSymptoms.options.cough",
      },
      {
        value: "morePhlegmOrMucus",
        labelKey: "episodeSymptoms.options.morePhlegmOrMucus",
      },
      {
        value: "phlegmOrMucusColourChange",
        labelKey: "episodeSymptoms.options.phlegmOrMucusColourChange",
      },
      {
        value: "wheezing",
        labelKey: "episodeSymptoms.options.wheezing",
      },
      {
        value: "chestTightness",
        labelKey: "episodeSymptoms.options.chestTightness",
      },
      {
        value: "reducedUsualActivities",
        labelKey: "episodeSymptoms.options.reducedUsualActivities",
      },
      {
        value: "nightTimeSymptoms",
        labelKey: "episodeSymptoms.options.nightTimeSymptoms",
      },
      {
        value: "other",
        labelKey: "episodeSymptoms.options.other",
      },
      {
        value: "unsure",
        labelKey: "episodeSymptoms.options.unsure",
      },
    ],
    exclusiveOptionValues: ["unsure"],
    freeTextFieldId: "RH_MO_EPISODE_SYMPTOMS_OTHER",
    freeTextTriggerValue: "other",
    freeTextTitleKey: "episodeSymptoms.otherTitle",
    freeTextPlaceholderKey: "episodeSymptoms.otherPlaceholder",
    condition: showsMonthlyFollowUpQuestions,
    group: "monthly-check-in",
  },
  {
    id: "RH_MO_TREATMENT_INCREASE",
    titleKey: "treatmentIncrease.title",
    title: "Treatment or oxygen use",
    fieldType: "radio",
    required: true,
    options: [
      {
        value: "NO",
        labelKey: "treatmentIncrease.options.no",
      },
      {
        value: "A_LITTLE_MORE",
        labelKey: "treatmentIncrease.options.aLittleMore",
      },
      {
        value: "SUBSTANTIALLY_MORE",
        labelKey: "treatmentIncrease.options.substantiallyMore",
      },
      {
        value: "NOT_APPLICABLE",
        labelKey: "treatmentIncrease.options.notApplicable",
      },
      {
        value: "UNSURE",
        labelKey: "treatmentIncrease.options.unsure",
      },
    ],
    condition: showsMonthlyFollowUpQuestions,
    group: "monthly-check-in",
  },
  {
    id: "RH_MO_HEALTHCARE_ACTION",
    titleKey: "healthcareAction.title",
    title: "Healthcare action",
    helperTextKey: "healthcareAction.helperText",
    fieldType: "checkbox-group",
    required: true,
    options: [
      {
        value: "usualPlan",
        labelKey: "healthcareAction.options.usualPlan",
      },
      {
        value: "contactedStudyTeam",
        labelKey: "healthcareAction.options.contactedStudyTeam",
      },
      {
        value: "contactedCommunityClinician",
        labelKey: "healthcareAction.options.contactedCommunityClinician",
      },
      {
        value: "contacted111",
        labelKey: "healthcareAction.options.contacted111",
      },
      {
        value: "receivedAntibiotics",
        labelKey: "healthcareAction.options.receivedAntibiotics",
      },
      {
        value: "receivedOralCorticosteroids",
        labelKey: "healthcareAction.options.receivedOralCorticosteroids",
      },
      {
        value: "attendedUrgentCare",
        labelKey: "healthcareAction.options.attendedUrgentCare",
      },
      {
        value: "admittedToHospital",
        labelKey: "healthcareAction.options.admittedToHospital",
      },
      {
        value: "none",
        labelKey: "healthcareAction.options.none",
      },
      {
        value: "unsure",
        labelKey: "healthcareAction.options.unsure",
      },
    ],
    exclusiveOptionValues: ["none", "unsure"],
    condition: showsMonthlyFollowUpQuestions,
    group: "monthly-check-in",
  },
  {
    id: "RH_MO_RECOVERY_STATUS",
    titleKey: "recoveryStatus.title",
    title: "Recovery status",
    fieldType: "radio",
    required: true,
    options: [
      {
        value: "COMPLETELY_BACK_TO_USUAL",
        labelKey: "recoveryStatus.options.completelyBackToUsual",
      },
      {
        value: "PARTLY_BACK_TO_USUAL",
        labelKey: "recoveryStatus.options.partlyBackToUsual",
      },
      {
        value: "NOT_BACK_TO_USUAL",
        labelKey: "recoveryStatus.options.notBackToUsual",
      },
      {
        value: "STILL_GETTING_WORSE",
        labelKey: "recoveryStatus.options.stillGettingWorse",
      },
      {
        value: "UNSURE",
        labelKey: "recoveryStatus.options.unsure",
      },
    ],
    condition: showsMonthlyFollowUpQuestions,
    group: "monthly-check-in",
  },
];

monthlyCheckInQuestionnaire.metadata = {
  titleKey: "title",
  introKey: "intro",
  contentVersion: MONTHLY_CHECK_IN_CONTENT_VERSION,
};

export default monthlyCheckInQuestionnaire;
